import { CloseBidComponent } from './../../components/close-bid/close-bid.component';
import { MatDialog } from '@angular/material/dialog';
import { AbstractControl, FormArray, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { GetSecondHandSuppliesBidsService } from '../../services/get-second-hand-supplies-bids.service';
import { BehaviorSubject } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { switchMap } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-bids-listing',
  templateUrl: './bids-listing.component.html',
  styleUrls: ['./bids-listing.component.scss']
})
export class BidsListingComponent implements OnInit {
  displayedColumns: string[] = ['sNo', 'username', 'price', 'message' , 'created_at'];
  dataSource: MatTableDataSource<any>;
  filterForm = this.fb.group({
    second_hand_supplies_id: [null, [Validators.required]],
    search: ['', [Validators.required]],
    limit: [50, [Validators.required]],
    filters: this.fb.array([]),
    sort: [[{"title":"asc"}]],
    offset: [0, [Validators.required]]
  });
  totalElements = 0;
  filterSubject: BehaviorSubject<any>;
  constructor(
    private fb: FormBuilder,
    private getSecondHandSuppliesBidsService: GetSecondHandSuppliesBidsService,
    private route: ActivatedRoute,
    private matDialog: MatDialog) { }

  ngOnInit(): void {
    this.second_hand_supplies_id.setValue(this.route.snapshot.paramMap.get('id'));
    this.filterSubject = new BehaviorSubject<any>(this.filterForm.value);
    this.filterSubject.pipe(switchMap(filter => {
      this.dataSource = null;
      return this.getSecondHandSuppliesBidsService.getSecondHandSuppliesBids(this.filterForm.value)
    })).subscribe(([second_hand_supplies_bids, count]: any)=>{
      console.log(second_hand_supplies_bids, count);
      this.dataSource = new MatTableDataSource<any>(second_hand_supplies_bids);
      this.totalElements = count;
    });
  }


  /* --------------------------------- Getters -------------------------------- */
  get second_hand_supplies_id(){
    return this.filterForm.get('second_hand_supplies_id');
  }
  get search() {
    return this.filterForm.get('search');
  }
  get sort() {
    return this.filterForm.get('sort');
  }
  get status(): AbstractControl {
    return this.filterForm.get("status");
  }
  get limit(): AbstractControl {
    return this.filterForm.get('limit');
  }
  get offset(): AbstractControl {
    return this.filterForm.get('offset');
  }
  get filters(): FormArray {
    return this.filterForm.get('filters') as FormArray;
  }
  changePage(ev: PageEvent){
    this.offset.setValue(ev.pageSize * ev.pageIndex);
    this.filterSubject.next(this.filterForm.value);
  }
  closeBidDialog(){
    const dialogRef = this.matDialog.open(CloseBidComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: this.second_hand_supplies_id.value
    });
    dialogRef.afterClosed().subscribe(status => {
      console.log(status);
      if (status === 'yes') {
        this.filterSubject.next(this.filterForm.value);
      }
      if (status === 'no') {
      }
    });
  }
}
